import { render, staticRenderFns } from "./BudgetInstances.vue?vue&type=template&id=5026d48f&scoped=true"
import script from "./BudgetInstances.vue?vue&type=script&lang=js"
export * from "./BudgetInstances.vue?vue&type=script&lang=js"
import style0 from "./BudgetInstances.vue?vue&type=style&index=0&id=5026d48f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5026d48f",
  null
  
)

export default component.exports